import { createContext } from 'react';

import { PricingSetFragment } from '@admin/schema';

export const PricingSetContext = createContext<Partial<PricingSetFragment>>({});
